module.exports = __webpack_public_path__ + "corporate-card-pattern.810998e401fc4f06ea49d677c1959f53.png";